import React from 'react';
import AuthButton from '../components/AuthButton';
import Logo_w from '../images/logomenu_w.png';
import localization from '../lib/localization/localization';
import hash from '../lib/pass-hash/pass-hash'

export default function AuthPage({authStart, ui_language, pushWindow}){    
    let login = ''
    let password = ''
    let auth_data

    async function click_auth_button(){
        login = document.getElementById('idLogin').value.replace(/\s/g, '');
        password = document.getElementById('idPassword').value;
        if ((login)&&(password)) {
            let pass_hash = await hash.hashPass(login, password)
            auth_data = {login: login, password: pass_hash, istoken: false, token: null, new_token: true}
            authStart(auth_data)
        }
        else pushWindow ('(＃ಠ_ಠ)  ' + localization.localize(ui_language).enter_log_pass)
    }
    //<img src={Logo_w} className="auth_logo"/>
    return(
        <div className="auth-page">
                <div className="auth_logo">CONNECT</div>
                <div><p>{localization.localize(ui_language).login}:</p><input type="text" className="txt" id="idLogin"/></div>
                <div><p>{localization.localize(ui_language).password}:</p><input type="password" className="txt" id="idPassword" onKeyPress={(e)=> {if (e.key === 'Enter') click_auth_button()}}/></div>
                <p></p>
                <AuthButton click_auth_button={click_auth_button} ui_language={ui_language}/>
        </div>
    )
}